import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PolicyAcceptanceProvider } from './contexts/PolicyAcceptanceContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { MessageNotificationProvider } from './contexts/MessageNotificationContext';
import { ReelsFeedProvider } from './contexts/ReelsFeedContext';
import { ThemeProvider } from './contexts/ThemeContext';
import AppRoutes from './routes';
import { ListingProvider } from 'contexts/ListingContext';
import BannedGuard from './components/moderation/BannedGuard';
import CorporateApprovalBanner from './components/CorporateApprovalBanner';
import CookieConsentBanner from './components/CookieConsentBanner';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <BannedGuard>
            <CorporateApprovalBanner />
            <CookieConsentBanner />
            <PolicyAcceptanceProvider>
              <NotificationProvider>
                <MessageNotificationProvider>
                  <ReelsFeedProvider>
                    <ListingProvider>
                      <AppRoutes />
                    </ListingProvider>
                  </ReelsFeedProvider>
                </MessageNotificationProvider>
              </NotificationProvider>
            </PolicyAcceptanceProvider>
          </BannedGuard>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
